"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.663 4.4a2.207 2.207 0 0 0-2.207 2.207c0 .522.2 1.014.54 1.413a.7.7 0 1 1-1.065.909 3.58 3.58 0 0 1-.875-2.322A3.607 3.607 0 0 1 8.663 3h1.993a3.5 3.5 0 0 1 3.5 3.5.7.7 0 1 1-1.4 0 2.1 2.1 0 0 0-2.1-2.1zm4.86 7.088H16.3a.7.7 0 1 0 0-1.4H3.7a.7.7 0 1 0 0 1.4h7.586l.127.048a2.1 2.1 0 0 1 1.343 1.959v.005a2.1 2.1 0 0 1-2.1 2.1h-2.1a2.1 2.1 0 0 1-2.1-2.1.7.7 0 1 0-1.4 0 3.5 3.5 0 0 0 3.5 3.5h2.1a3.5 3.5 0 0 0 3.5-3.5v-.005a3.5 3.5 0 0 0-.633-2.007",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StrikeoutIcon20.js.map